// extracted by mini-css-extract-plugin
export default {"secondary-button-disabled":"app_secondary-button-disabled__P-5bH","app":"app_app__9OAH2"};